export const BRAND = {
    name: "ModernLand",
    tagline: "Find Your Perfect Place",
    logo: "/logo.png",
    logoDark: "/logo-dark.png",
    favicon: "/favicon.ico",
    hotline: import.meta.env.VITE_HOTLINE,
    address: import.meta.env.VITE_COM_ADDRESS,
    hello_mail: import.meta.env.VITE_HELLO_MAIL,
    support_mail: import.meta.env.VITE_SUPPORT_MAIL,
};
